// Pass in Redux store's state to save it to the user's browser local storage
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("languages", serializedState);
    // localStorage.setItem("language", "en");
  } catch {
    // We'll just ignore write errors
  }
};

// Loads the state and returns an object that can be provided as the
// preloadedState parameter of store.js's call to configureStore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("languages");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return undefined;
  }
};
